<template>
<div class="d-flex align-items-center">

    <el-form :inline="true" class="d-inline-flex"
    label-position="left" label-width="30%">

        <el-form-item label="tag" v-if="user.type === 'gaa'">
            <el-select :placeholder="`（${$t('AccountTagInput.Please_Select')}）`" name="tag" v-model="input" size="small" clearable filterable remote multiple reserve-keyword
            @change="applyTags"
            :remote-method="fetchSuggestTags" :loading="loading"
            class="tag-input-select">
                <el-option v-for="tag in suggestTag" :key="tag.name"
                :label="tag.name" :value="tag.name">
                </el-option>
            </el-select>
        </el-form-item>

    </el-form>
    
</div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'account-tag-input',
    props: {
        user: Object,
    },

    data() {
        return {
            input: [],
            loading: false,
            suggestTag: [],
        }
    },

    mounted() {
        this.fetchSuggestTags();
    },

    methods: {
        applyTags() {
            this.$emit('apply-tags', this.input);
        },
        async fetchSuggestTags(keyword) {
            try {
                this.loading = true;
                let config = {
                    method: 'GET',
                    params: {
                        keyword: keyword
                    },
                    url: `${process.env.VUE_APP_APIHOST}/${this.user.type}/tags/account-tags`
                }

                let response = await axios(config);
                this.suggestTag = response.data;

            } catch (error) {
                console.error(`Cannot fetch suggest account tags`, error);
            }

            this.loading = false;
        },
    }
};
</script>

<style scoped>
.tag-input-select >>> .el-input__inner {
    border-radius: 5px;
    padding: 8px 5px;
    min-width: 199.11px;
}

.tag-input-select >>> .el-tag {
    margin: 3px 1px !important;
    padding: 5px;
    background-color: #fd7e14 !important;
    border-color: #fd7e14;
}

.el-form-item {
  margin-bottom: 0;
}
</style>